import React from 'react';
import OnVisible from 'react-on-visible';

import RenderContent from '../../RenderContent'
import { decodeEntities } from '../../../utils/helpers'
import GatsbyLink from '../../GatsbyLink'
import Heading from '../../Heading/Heading';
import { Image } from '../../Image';
import './TextImageColumns.scss';

export const TextImageColumns = props => {
  const { columns } = props;
  return (
    <section className="text-image-columns">
      <div className="wrap">
        {columns && columns.length > 0 && (
          <div className="columns-container">
            {columns.map(column => (
              <div className="column" key={column.title}>
                <OnVisible className="image-container">
                  <GatsbyLink to={column.link.url}>
                    <Image src={column.image} className="image" />
                  </GatsbyLink>
                </OnVisible>
                {column.title && <Heading tag="h2" className="section-title">{decodeEntities(column.title)}</Heading>}
                {column.text && <RenderContent className="content" content={column.text} />}
                {column.link && <GatsbyLink to={column.link.url} className="action" decode>{column.link.title}</GatsbyLink>}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
